import React from "react";

const defaultRiskActionsProgressData = [
  {
    sno: 1,
    riskOrOpportunity: "",
    actionsTakenPast: "",
    plannedActionsFuture: "",
    progressSinceLast: "",
  },
];

const RiskActionsProgressTable = ({
  riskActionsProgressData,
  setRiskActionsProgressData,
}) => {
  const handleChange = (index, field, value) => {
    const updated = [...riskActionsProgressData];
    updated[index][field] = value;
    setRiskActionsProgressData(updated);
  };
  const renumberRows = (arr) => arr.map((r, i) => ({ ...r, sno: i + 1 }));
  const addRow = () =>
    setRiskActionsProgressData([
      ...riskActionsProgressData,
      {
        sno: (riskActionsProgressData?.length || 0) + 1,
        riskOrOpportunity: "",
        actionsTakenPast: "",
        plannedActionsFuture: "",
        progressSinceLast: "",
      },
    ]);

  const removeRow = () => {
    if (riskActionsProgressData.length > 1) {
      setRiskActionsProgressData(
        renumberRows(riskActionsProgressData.slice(0, -1))
      );
    }
  };

  // Removed per-cell border; outer frame + inner grid handle borders
  const cell = {
    padding: "15px",
    textAlign: "left",
    verticalAlign: "top",
  };

  const header = {
    ...cell,
    backgroundColor: "#d3c9ce",
    fontWeight: "bold",
    textAlign: "center",
  };

  const inputStyle = {
    width: "100%",
    padding: "15px",
    border: "1px solid gray",
    borderRadius: "4px",
    fontSize: "14px",
  };

  const textAreaStyle = {
    ...inputStyle,
    minHeight: "70px",
    resize: "vertical",
  };

  const buttonStyle = {
    backgroundColor: "white",
    border: "1px solid lightgrey",
    color: "grey",
    borderRadius: "4px",
    padding: "8px 12px",
    cursor: "pointer",
  };

  return (
    <div style={{ overflowX: "auto", marginTop: 20 }}>
      {/* table frame + perfect corners */}
      <style>{`
        .rapTableFrame{
          border: 1px solid #000;
          border-radius: 8px;
          overflow: hidden;
        }
        .rapTable{
          width: 100%;
          border-collapse: collapse;
        }
        .rapTable th,
        .rapTable td{
          border: 1px solid #000;   /* inner grid lines */
          padding: 15px;
          vertical-align: top;
          text-align: left;
        }
        .rapTable thead th{
          background: #d3c9ce;
          font-weight: 700;
          text-align: center;
        }
        /* hide outer edges; frame draws outside border */
        .rapTable thead tr:first-child th{ border-top: 0; }
        .rapTable tr th:first-child,
        .rapTable tr td:first-child{ border-left: 0; }
        .rapTable tr th:last-child,
        .rapTable tr td:last-child{ border-right: 0; }
        .rapTable tbody tr:last-child td{ border-bottom: 0; }
      `}</style>

      <div className="rapTableFrame">
        <table className="rapTable">
          <thead>
            <tr>
              <th style={{ ...header, width: 70 }}>
                S.
                <br />
                NO.
              </th>
              <th style={header}>Risk/Opportunity</th>
              <th style={header}>
                Actions Taken
                <br />
                (Past Response)
              </th>
              <th style={header}>
                Planned Actions
                <br />
                (Future Response)
              </th>
              <th style={header}>
                Progress Since Last
                <br />
                Reporting (Quantitative
                <br />
                &amp; Qualitative)
              </th>
            </tr>
          </thead>

          <tbody>
            {riskActionsProgressData.map((row, index) => (
              <tr key={index}>
                <td style={cell}>{row.sno || index + 1}.</td>

                <td style={cell}>
                  <input
                    type="text"
                    placeholder="Enter data"
                    value={row.riskOrOpportunity}
                    onChange={(e) =>
                      handleChange(index, "riskOrOpportunity", e.target.value)
                    }
                    style={inputStyle}
                  />
                </td>

                <td style={cell}>
                  <textarea
                    placeholder="Enter data"
                    value={row.actionsTakenPast}
                    onChange={(e) =>
                      handleChange(index, "actionsTakenPast", e.target.value)
                    }
                    style={textAreaStyle}
                  />
                </td>

                <td style={cell}>
                  <textarea
                    placeholder="Enter data"
                    value={row.plannedActionsFuture}
                    onChange={(e) =>
                      handleChange(
                        index,
                        "plannedActionsFuture",
                        e.target.value
                      )
                    }
                    style={textAreaStyle}
                  />
                </td>

                <td style={cell}>
                  <textarea
                    placeholder="Enter data"
                    value={row.progressSinceLast}
                    onChange={(e) =>
                      handleChange(index, "progressSinceLast", e.target.value)
                    }
                    style={textAreaStyle}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: 10,
          gap: 10,
        }}
      >
        <button onClick={removeRow} style={buttonStyle}>
          - Remove
        </button>
        <button onClick={addRow} style={buttonStyle}>
          + Add More
        </button>
      </div>
    </div>
  );
};

export default RiskActionsProgressTable;
